// extracted by mini-css-extract-plugin
export default {"logs":"logs_logs__-FPg8","content":"logs_content__sUeO4","logs_datepicker":"logs_logs_datepicker__Zpf-B","ar":"logs_ar__UxSwa"};